export const filterOptions = ['Select option', 'tcp', 'udp', 'both'];
export const forwardPortObject = {
  srcIP: '',
  srcIPMessage: '',
  srcIPValid: false,
  srcIPShowMsg: false,

  srcStartPort: null,
  srcStartPortMessage: '',
  srcStartPortValid: false,
  srcStartPortShowMsg: false,

  srcEndPort: null,
  srcEndPortMessage: '',
  srcEndPortValid: false,
  srcEndPortShowMsg: false,

  dstIP: '',
  dstIPMessage: '',
  dstIPValid: false,
  dstIPShowMsg: false,

  dstStartPort: null,
  dstStartPortMessage: '',
  dstStartPortValid: false,
  dstStartPortShowMsg: false,

  dstEndPort: null,
  dstEndPortMessage: '',
  dstEndPortValid: false,
  dstEndPortShowMsg: false,

  proto: '',
  protoValid: false,

  enable: true,
  submit: false,
};
